import React from 'react';
import { Link } from 'react-router-dom';

import { Card, CardContent, Typography, CardActionArea } from '@material-ui/core';

const homeAction = (props) => {
    if(props.linkTo) {
        return (
            <Card>
                <CardActionArea component={Link} to={props.linkTo || '/'}>
                    <CardContent>
                        <Typography variant="h6" align="center">{props.title}</Typography>
                        {props.content || props.children}
                    </CardContent>
                </CardActionArea>
            </Card>
        );
    }
    else {
        return (
            <Card>
                <CardContent>
                    <Typography variant="h6" align="center">{props.title}</Typography>
                    {props.content || props.children}
                </CardContent>
            </Card>
        );
    }
}

export default homeAction;